import { useEffect } from "react";

const SITE_URL = "https://etelecom.in";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  const existing = document.getElementById(id);
  if (existing) existing.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(data);
  document.head.appendChild(script);
}

/**
 * Lightweight SEO manager (title, meta, OG, canonical, JSON-LD) without
 * external dependencies. Runs on mount / when values change.
 */
export function useSEO({ title, description, path = "/", jsonLd = null } = {}) {
  useEffect(() => {
    const fullUrl = `${SITE_URL}${path}`;
    if (title) document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", fullUrl);
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setCanonical(fullUrl);
    setJsonLd("page-jsonld", jsonLd);
    return () => setJsonLd("page-jsonld", null);
  }, [title, description, path, jsonLd]);
}
